// Permission check messages and warnings
export const PERMISSION_MESSAGES = {
  // Critical warnings (always shown)
  CRITICAL: {
    BROWSER_NOT_SUPPORTED: 'Browser does not support media recording features',
    CAMERA_NOT_FOUND: 'No camera device found',
    MICROPHONE_NOT_FOUND: 'No microphone device found',
    GETUSERMEDIA_UNAVAILABLE: 'Media access API not available',
  },

  // Browser-specific warnings (shown conditionally)
  BROWSER_SPECIFIC: {
    IOS_CHROME_LIMITED:
      'Chrome on iOS has limited media recording capabilities. Use Safari for better experience.',
    IOS_SAFARI_UNRELIABLE: 'iOS Safari permission states may be unreliable',
    FIREFOX_MOBILE_PROMPTS: 'Firefox mobile may require additional permission prompts',
  },

  // Permission state messages
  PERMISSION_STATE: {
    CAMERA_DENIED: 'Camera access was previously denied.',
    MICROPHONE_DENIED: 'Microphone access was previously denied.',
    BOTH_DENIED: 'Camera and microphone access were previously denied.',
    RESET_INSTRUCTIONS: (hasVideoDenied: boolean, hasAudioDenied: boolean): string => {
      if (hasVideoDenied && hasAudioDenied) {
        return 'Please check your browser settings to reset camera and microphone permissions, then refresh the page.';
      }
      if (hasVideoDenied) {
        return 'Please check your browser settings to reset camera permissions, then refresh the page.';
      }
      if (hasAudioDenied) {
        return 'Please check your browser settings to reset microphone permissions, then refresh the page.';
      }
      return ''; // fallback if neither denied
    },
  },
} as const;
